import { render, staticRenderFns } from "./ChartPie.vue?vue&type=template&id=d7dc3b1c&"
import script from "./ChartPie.vue?vue&type=script&lang=js&"
export * from "./ChartPie.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports